import { render, staticRenderFns } from "./hpSection1.vue?vue&type=template&id=781e1ac2&scoped=true&"
var script = {}
import style0 from "./hpSection1.vue?vue&type=style&index=0&id=781e1ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781e1ac2",
  null
  
)

export default component.exports